import { FaBars } from "react-icons/fa";
import styled from "styled-components";
import colors from "../../../../../../styles/colors";

export const ListItemsContainer = styled.div`
  align-items: center;
  display: flex;
  margin: 1rem;
`;

export const AnswerFlex = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ListItemNumber = styled.span`
  font-weight: bold;
  margin-right: 1.5rem;
`;

export const ListItemsHint = styled.div`
  background-color: ${colors.lightyellow};
  border-radius: 1rem;
  margin: 0.75rem 0rem;
  padding: 0.5rem 1rem;
  position: relative;

  &::after {
    content: "";
    border-color: ${colors.lightyellow} transparent transparent transparent;
    border-style: solid;
    border-width: 0.75rem;
    left: 50%;
    margin-left: -0.75rem;
    position: absolute;
    top: 100%;
  }
`;

export const AddNewList = styled.button`
  align-items: center;
  border: ${colors.teal} dashed 0.2rem;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  color: ${colors.teal};
  font-size: 1.75rem;
  justify-content: center;
  margin: 0.75rem 0rem;
  opacity: 0.65;
  padding: 1.5rem 0.5rem;
  width: 100%;
  &:hover {
    opacity: 1;
  }
`;

export const AddNewListText = styled.span`
  margin-left: 1rem;
`;

export const HiddenInput = styled.input.attrs({
  placeholder: "Enter the possible answers, pressing Enter to confirm them.",
})`
  background-color: transparent;
  border: none;
  flex: auto;
  font-size: 1.5rem;
  padding: 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: fit-content;
  &:focus {
    outline: none;
  }
`;

export const ListItemOptions = styled.div`
  display: flex;
  position: absolute;
  top: 5%;
  right: 0%;
  z-index: 999;
`;

export const DragBars = styled(FaBars)`
  cursor: move;
  display: flex;
  align-items: center;
`;
